import axios from "axios";

// TOGGLE THESE COMMENTS BASED ON ENVIRONMENT:

// OPTION 1: Local Development
//const BASE_URL = "http://localhost:8080";

// OPTION 2: Production (Live)
const BASE_URL = "https://june-backend-7alv.onrender.com";

// 1. Create the instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  //withCredentials: true,
});

// 2. Request Interceptor: Injects the Access Token
axiosInstance.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("accessToken");
    if (token) {
      // Clean up the string (remove extra quotes if present)
      token = token.replace(/^"|"$/g, "");
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 3. Response Interceptor: Handles Token Refresh
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (
      originalRequest.url.includes("/authenticate") ||
      originalRequest.url.includes("/login")
    ) {
      return Promise.reject(error);
    }

    // Check if error is 403 (Forbidden) or 401 (Unauthorized) and we haven't retried yet
    if (
      (error.response?.status === 403 || error.response?.status === 401) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        // A. Get the Refresh Token from storage
        let refreshToken = localStorage.getItem("refreshToken");

        if (!refreshToken) {
          throw new Error("No refresh token available");
        }

        refreshToken = refreshToken.replace(/^"|"$/g, "");

        // B. Call the backend refresh endpoint
        // Your backend requires the Refresh Token in the Authorization Header
        const response = await axios.post(
          "http://localhost:8080/api/v1/auth/refresh-token",
          {}, // Body is empty
          {
            headers: {
              Authorization: `Bearer ${refreshToken}`,
            },
          }
        );

        // C. Save the new tokens
        const { accessToken, refreshToken: newRefreshToken } = response.data;

        localStorage.setItem("accessToken", JSON.stringify(accessToken));
        localStorage.setItem("refreshToken", JSON.stringify(newRefreshToken));

        // D. Update the header for the original request and retry it
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // E. If refresh fails (e.g., refresh token is also expired), force logout
        console.error("Session expired, logging out...", refreshError);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        localStorage.removeItem("userRole");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
